import styled from 'styled-components';
import { mediaMax } from '../Media Template/Media Template';

export const SpecsSideBar = styled.div.attrs({ className: 'SpecsSideBar' })`
  width: 300px;
  /* max-width: 300px; */
  margin-left: 14px;
  tr {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 0.5rem;
  }
  .column-1 {
    font-size: 0.875rem;
    display: list-item;
    list-style: disc;
    list-style-position: outside;
  }
  .column-2 {
    font-size: 1rem;
    padding-left: 1.2rem;
  }
  ${mediaMax.desktop`
    width: 100%;
    max-width: 300px;
  `};
`;

export const SpecsSideBarCard = styled.li.attrs({
  className: 'SpecsSideBarCard'
})`
  width: 100%;
  max-width: 726px;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  cursor: pointer;
`;

export const SpecsSideBarCardData = styled.div.attrs({
  className: 'SpecsSideBarCardData'
})`
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;
